export const defaultValues = {
  brand: null,
  type: null,
  accountId: null,
  studio: null,
  normalLiveHours: null,
  normalStart: null,
  normalEnd: null,
  paydayLiveHours: null,
  paydayStart: null,
  paydayEnd: null,
  isUseAgency: false,
  agencyNormalStart: null,
  agencyNormalEnd: null,
  agencyPaydayStart: null,
  agencyPaydayEnd: null,
  host: null,
  selectedHost: [],
};
